<template>
    <div class="step-4">
        <h2><trans msg="step4_title" /></h2>
        <p><trans msg="step4_description" /></p>
        <label><trans msg="step4_label" /></label>
        <button value="EUR" :class="{active: currency === 'EUR', inactive: currency && currency != 'EUR'}" @click="change_value">&euro;</button>
        <button value="USD" :class="{active: currency === 'USD', inactive: currency && currency !== 'USD'}" @click="change_value">$</button>
        <label class="form-error" v-if="invalid.indexOf('currency') != -1"><trans msg="step4_error" /></label>
    </div>
</template>

<script>

import Translation from './Translation.vue'

export default {
  name: 'step-4',
  props: ['currency', 'invalid'],
  methods: {
    change_value: function(ev) {
        this.$emit('change_value', ev.target.value);
    }
  },
  components: {
    'trans': Translation
  }
}
</script>

<style scoped>
button {
    background: white;
    border: solid 1px #35bacf;
    color: #35bacf;
    transition: background-color .5s, border-color .5s, color .5s;
}

button.active {
    background: #35bacf;
    color: white;
}

button.inactive {
    background: #eee;
    color: #ccc;
    border-color: #eee;
}

</style>



// WEBPACK FOOTER //
// Step4.vue?60d9cc72